import React from 'react';
import useStyle from './checkListDisplay.module.scss';

export default function ChecklistPrintDisplay(props) {
  const {
    useFieldData,
    check_list_answers = false,
    isPrintWithoutData
  } = props;

  const checkStatusDot = (mainCheckId, subCheckId) => {
    let useDot;
    if (
      check_list_answers?.[mainCheckId]
      && subCheckId in check_list_answers?.[mainCheckId]
    ) {
      if (check_list_answers?.[mainCheckId]?.[subCheckId]
        ?.check_lilst_status === 'N/A') {
        useDot = 'N/A';
      } else if (check_list_answers?.[mainCheckId]?.[subCheckId]
        ?.check_lilst_status) {
        useDot = 'Yes';
      } else {
        useDot = 'No';
      }
    } else {
      useDot = 'No';
    }
    return useDot;
  };

  return (
    <table className={useStyle.table}>
      <thead className={useStyle.itemWrapper}>
        {useFieldData?.schema?.fields?.length > 0
          && useFieldData.schema.fields
            .filter(field => field.type === 'inspection')
            ?.map(eachCheck => (
              <>
                <tr style={{ display: 'table-row' }}>
                  <th style={{ padding: '0px' }}>
                    <div className={useStyle.infoFull}>
                      <span
                        className={useStyle.fullwidth}
                        style={{
                          fontSize: '18px',
                          fontFamily: 'serif !important',
                          fontWeight: '300'
                        }}
                      >
                        {eachCheck?.title || 'New'}
                      </span>
                    </div>
                    {eachCheck?.checklist?.map(subCheck => (
                      <>
                        <div
                          className={useStyle.checklist__item}
                          style={{
                            marginTop: '0.8rem',
                            borderBottom: '1px solid #E6EAEE'
                          }}
                        >
                          <tr>
                            <td
                              width="800"
                              style={{
                                borderRight: '1px solid rgb(230, 234, 238)'
                              }}
                            >
                              <span
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '18px',
                                  fontFamily: 'serif !important',
                                  fontWeight: '400'
                                }}
                              >
                                {subCheck?.value}
                              </span>
                            </td>
                          </tr>

                          <tr>
                            <td
                              width="500"
                              style={{
                                borderRight: '1px solid rgb(230, 234, 238)'
                              }}
                            >
                              {!isPrintWithoutData && (
                                <p className={useStyle.spanstyles}>
                                  {checkStatusDot(
                                    eachCheck?.id,
                                    subCheck?.key
                                  )}
                                </p>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td
                              width="500"
                              style={{
                                borderRight: '1px solid rgb(230, 234, 238)',
                                wordBreak: 'break-word'
                              }}
                            >
                              {!isPrintWithoutData && (
                                <p className={useStyle.spanstyles}>
                                  {check_list_answers[eachCheck.id]?.[
                                    subCheck?.key
                                  ]?.checklist_remarks_list || ''}
                                </p>
                              )}
                            </td>
                          </tr>
                        </div>
                      </>
                    ))}
                  </th>
                </tr>
              </>
            ))}
      </thead>
    </table>
  );
}
